var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleMobiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a18e5de9-d875-48cd-8811-d1fd01754d89",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.03,
    height: 13.83,
    viewBox: "0 0 8.03 13.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-6f99c658-080c-4a6c-93c3-8a83e7ec08b4",
    "data-name": "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.84,13.83H.19c-.11,0-.19-.09-.19-.19V.19c0-.11.09-.19.19-.19h7.64c.11,0,.19.09.19.19v13.44c0,.11-.09.19-.19.19ZM.39,13.44h7.25V.39H.39v13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73,11.49H.3c-.11,0-.19-.09-.19-.19s.09-.19.19-.19h7.44c.11,0,.19.09.19.19s-.09.19-.19.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81,12.66h-1.59c-.11,0-.19-.09-.19-.19s.09-.19.19-.19h1.59c.11,0,.19.09.19.19s-.09.19-.19.19Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleMobiles);
export default __webpack_public_path__ + "static/media/icon_module_mobiles.45e9a07ef60a00851b60979a1083fb33.svg";
export { ForwardRef as ReactComponent };